import Link from 'next/link';
import React from 'react';
import { AnchorProps } from '~/components/Links/A';

type Props = AnchorProps & {};

const BuyingGuidesLink: React.FC<Props> = ({ children, ...props }) => (
  <Link prefetch={false} href="/buying-guides" {...props}>
    {children}
  </Link>
);

export default BuyingGuidesLink;
